module.exports = __webpack_public_path__ + "static/img/3.ac5d864.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/sp/3.png
// module id = rLh+
// module chunks = 0